/**
 * Wishlist Stock Control
 * Tüm sayfalarda sepete ekleme işlemlerinde stok kontrolü yapar
 * Wishlist, Search, Product ve diğer tüm sayfalarda çalışır
 */

(function() {
    'use strict';
  
    const pathname = window.location.pathname;
  
    // RTL/Arapça desteği için dil kontrolü
    const htmlLang = document.documentElement.lang || '';
    const isArabic = htmlLang.startsWith('ar') || document.documentElement.dir === 'rtl';
    const toastPosition = isArabic ? 'left' : 'right';
  
    console.log('🛒 Stock control: Script initialized on:', pathname, '| RTL:', isArabic);
  
    // XMLHttpRequest'i de intercept et (wishlist app belki bunu kullanıyordur)
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;
  
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this._url = url;
      this._method = method;
      return originalXHROpen.call(this, method, url, ...rest);
    };
  
    // XHR pre-check için yardımcı: body'den variant ID ve quantity çıkar
    function parseXHRBody(body) {
      let variantId = null;
      let qty = 1;
      try {
        if (body instanceof FormData) {
          variantId = body.get('id');
          qty = parseInt(body.get('quantity') || '1', 10);
        } else if (typeof body === 'string') {
          // URL-encoded form data: id=123&quantity=1
          if (body.includes('=') && !body.startsWith('{')) {
            const params = new URLSearchParams(body);
            variantId = params.get('id');
            qty = parseInt(params.get('quantity') || '1', 10);
          } else {
            const data = JSON.parse(body);
            variantId = data.id || data.items?.[0]?.id;
            qty = data.quantity || data.items?.[0]?.quantity || 1;
          }
        }
      } catch (e) {}
      if (variantId) variantId = Number(variantId);
      return { variantId, qty };
    }

    // XHR pre-check: inventory bilgisi DOM'dan al (fetch interceptor ile aynı mantık)
    function getInventoryFromDOM(variantId) {
      let inventory = null;

      // 1. data-variant-id ile
      const variantEl = document.querySelector(`[data-variant-id="${variantId}"]`);
      if (variantEl && variantEl.dataset.inventory) {
        const inv = parseInt(variantEl.dataset.inventory, 10);
        if (!isNaN(inv) && inv < 999999) inventory = inv;
      }

      // 2. Variant popup butonu
      if (inventory === null) {
        const variantBtn = document.querySelector(`.variant-option[data-variant-id="${variantId}"]`);
        if (variantBtn && variantBtn.dataset.inventory) {
          const inv = parseInt(variantBtn.dataset.inventory, 10);
          if (!isNaN(inv) && inv < 999999) inventory = inv;
        }
      }

      // 3. Wishlist kartları
      if (inventory === null && window.location.pathname.includes('/apps/wishlist')) {
        const allCards = document.querySelectorAll('wishlist-product-card');
        for (const card of allCards) {
          const input = card.querySelector('input[name="id"]');
          if (input && Number(input.value) === variantId) {
            if (card.dataset.inventoryMap) {
              try {
                const invMap = JSON.parse(card.dataset.inventoryMap);
                const inv = invMap[String(variantId)];
                if (inv !== undefined) {
                  const invNum = parseInt(inv, 10);
                  if (!isNaN(invNum) && invNum < 999999) inventory = invNum;
                }
              } catch (e) {}
            }
            if (inventory === null && card.dataset.inventory) {
              const inv = parseInt(card.dataset.inventory, 10);
              if (!isNaN(inv) && inv < 999999) inventory = inv;
            }
            break;
          }
        }
      }

      return inventory;
    }

    XMLHttpRequest.prototype.send = function(body) {
      if (this._url && this._url.includes('/cart/add')) {
        console.log('🛒 XHR: Intercepting cart/add request');
        const xhr = this;

        // XHR Pre-check: Stok kontrolü yap
        const { variantId, qty } = parseXHRBody(body);
        if (variantId) {
          const isPDPPage = window.location.pathname.match(/\/products\/[^/]+$/);
          if (!isPDPPage) {
            // Mevcut sepeti kontrol et ve stok pre-check yap
            originalFetch('/cart.js')
              .then(r => r.json())
              .then(async currentCart => {
                const existingItem = currentCart.items?.find(item => Number(item.id) === variantId);
                const currentQtyInCart = existingItem ? existingItem.quantity : 0;

                let availableStock = getInventoryFromDOM(variantId);

                // DOM'dan bulunamadıysa API'den dene
                if (availableStock === null) {
                  let productHandle = existingItem?.handle;
                  if (!productHandle) {
                    // Wishlist kartından handle bul
                    if (window.location.pathname.includes('/apps/wishlist')) {
                      const allCards = document.querySelectorAll('wishlist-product-card');
                      for (const card of allCards) {
                        const input = card.querySelector('input[name="id"]');
                        if (input && Number(input.value) === variantId) {
                          const link = card.querySelector('.wk-text-link[href*="/products/"]');
                          if (link) {
                            const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
                            if (match) productHandle = match[1];
                          }
                          break;
                        }
                      }
                    }
                  }
                  if (productHandle) {
                    try {
                      const productResponse = await originalFetch(`/products/${productHandle}.js`);
                      const productData = await productResponse.json();
                      const variant = productData.variants?.find(v => Number(v.id) === variantId);
                      if (variant && typeof variant.inventory_quantity === 'number') {
                        availableStock = variant.inventory_quantity;
                      }
                    } catch (e) {}
                  }
                }

                console.log('🛒 XHR Pre-check:', { variantId, currentQtyInCart, qty, availableStock });

                if (availableStock !== null && (currentQtyInCart + qty) > availableStock) {
                  const remainingStock = Math.max(0, availableStock - currentQtyInCart);
                  console.warn('🛒 XHR: BLOCKED - Stock limit exceeded');

                  window.__wishlistStockBlocked = variantId;
                  window.__wishlistStockBlockTime = Date.now();
                  window.__wishlistPreBlocked = true;

                  const stockMessage = remainingStock === 0
                    ? (window.themeTranslations?.backInStock || 'Bu üründen daha fazla ekleyemezsiniz. Stok limiti dolmuştur.')
                    : `Bu üründen en fazla ${remainingStock} adet daha ekleyebilirsiniz.`;

                  if (window.Toastify) {
                    Toastify({
                      text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${stockMessage}`,
                      duration: 3000,
                      className: 'stock-alert-container',
                      style: { background: "#000", color: "#fff" },
                      escapeMarkup: false,
                      newWindow: true,
                      close: false,
                      gravity: "top",
                      position: toastPosition,
                      stopOnFocus: true,
                      onClick: function () { }
                    }).showToast();
                  }

                  setTimeout(() => {
                    window.__wishlistStockBlocked = null;
                    window.__wishlistStockBlockTime = null;
                  }, 1000);

                  // XHR'ı abort et - isteği gönderme
                  xhr.abort();
                  return;
                }

                // Stok uygun - asıl isteği gönder
                window.__wishlistPreBlocked = false;
                originalXHRSend.call(xhr, body);
              })
              .catch(() => {
                // Pre-check hata verirse yine de gönder
                window.__wishlistPreBlocked = false;
                originalXHRSend.call(xhr, body);
              });
            return; // Async pre-check çalışacak, hemen gönderme
          }
        }

        // Post-response error handler (mevcut kod)
        this.addEventListener('load', function() {
          if (this.status >= 400) {
            console.error('🛒 XHR: Cart add error', this.status, this.responseText);

            try {
              const errorData = JSON.parse(this.responseText);
              const errorMsg = errorData?.description || errorData?.message || 'Sepete eklenemedi';

              // Toast mesajı göster
              if (window.Toastify) {
                setTimeout(() => {
                  Toastify({
                    text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${errorMsg}`,
                    duration: 3000,
                    className: 'stock-alert-container',
                    style: {
                      background: "#000",
                      color: "#fff",
                    },
                    escapeMarkup: false,
                    newWindow: true,
                    close: false,
                    gravity: "top",
                    position: toastPosition,
                    stopOnFocus: true,
                    onClick: function () { }
                  }).showToast();
                }, 100);
              }

              // Cart notification'ı kapat
              const cartNotification = document.querySelector('cart-notification');
              if (cartNotification) {
                setTimeout(() => {
                  if (cartNotification.classList.contains('active')) {
                    cartNotification.classList.remove('active');
                  }
                }, 150);
              }
            } catch (e) {
              console.error('🛒 XHR: Error parsing response:', e);
            }
          }
        });
      }

      return originalXHRSend.call(this, body);
    };
  
    // Sepet state'ini takip et
    let cartBeforeAdd = null;
  
    // Fetch API'yi de intercept et
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url, options] = args;
  
      // Eğer cart/add.js isteğiyse
      if (url && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
        console.log('🛒 Fetch: Intercepting cart/add request', url);
  
        // Önce mevcut sepeti al
        return originalFetch('/cart.js')
          .then(r => r.json())
          .then(async currentCart => {
            cartBeforeAdd = currentCart;
            console.log('🛒 Fetch: Cart before add:', cartBeforeAdd);
  
            // Request body'den eklenecek varyantı al
            let requestedVariantId = null;
            let requestedQty = 1;
            try {
              if (options?.body instanceof FormData) {
                // product-form.js FormData gönderir
                requestedVariantId = options.body.get('id');
                requestedQty = parseInt(options.body.get('quantity') || '1', 10);
              } else {
                const bodyData = JSON.parse(options?.body || '{}');
                requestedVariantId = bodyData.id || bodyData.items?.[0]?.id;
                requestedQty = bodyData.quantity || bodyData.items?.[0]?.quantity || 1;
              }
              // Number'a çevir - string/number karşılaştırma sorunu önlemek için
              if (requestedVariantId) requestedVariantId = Number(requestedVariantId);
            } catch (e) {
              console.log('🛒 Fetch: Could not parse request body');
            }
  
            // Sepette bu variant zaten var mı kontrol et
            if (requestedVariantId && cartBeforeAdd.items) {
              const existingItem = cartBeforeAdd.items.find(item => Number(item.id) === requestedVariantId);
              const currentQtyInCart = existingItem ? existingItem.quantity : 0;
  
              // Product handle'ı bul - önce sepetten, yoksa DOM'dan
              let productHandle = existingItem ? existingItem.handle : null;
  
              // DOM'dan inventory bilgisini HER ZAMAN almaya çalış (sepette olsa bile)
              let inventoryFromDOM = null;
  
              // 1. data-variant-id ile elementi bul ve inventory al
              const variantEl = document.querySelector(`[data-variant-id="${requestedVariantId}"]`);
              if (variantEl) {
                // data-inventory varsa al
                if (variantEl.dataset.inventory) {
                  const inv = parseInt(variantEl.dataset.inventory, 10);
                  if (!isNaN(inv) && inv < 999999) {
                    inventoryFromDOM = inv;
                  }
                }
                // Handle yoksa DOM'dan al
                if (!productHandle && variantEl.dataset.handle) {
                  productHandle = variantEl.dataset.handle;
                }
                // Parent'tan handle al
                if (!productHandle) {
                  const cardWrapper = variantEl.closest('.card-wrapper, .card, li.grid__item, .quick-add-in-search');
                  if (cardWrapper) {
                    const handleEl = cardWrapper.querySelector('[data-handle]');
                    if (handleEl) {
                      productHandle = handleEl.getAttribute('data-handle');
                    }
                  }
                }
              }
  
              // 2. Variant popup'ındaki butonu kontrol et (search page variant popup)
              if (inventoryFromDOM === null) {
                const variantBtn = document.querySelector(`.variant-option[data-variant-id="${requestedVariantId}"]`);
                if (variantBtn) {
                  if (variantBtn.dataset.inventory) {
                    const inv = parseInt(variantBtn.dataset.inventory, 10);
                    if (!isNaN(inv) && inv < 999999) {
                      inventoryFromDOM = inv;
                    }
                  }
                  if (!productHandle && variantBtn.dataset.handle) {
                    productHandle = variantBtn.dataset.handle;
                  }
                  if (!productHandle) {
                    const tile = variantBtn.closest('li.grid__item, .quick-add-in-search');
                    if (tile) {
                      const openBtn = tile.querySelector('.js-open-variants[data-handle]');
                      if (openBtn) productHandle = openBtn.getAttribute('data-handle');
                    }
                  }
                }
              }
  
              // 3. Son açık olan variant popup'ını kontrol et
              if (!productHandle) {
                const openPop = document.querySelector('.variant-pop:not([hidden])');
                if (openPop) {
                  if (openPop.dataset.productHandle) {
                    productHandle = openPop.dataset.productHandle;
                  } else {
                    const tile = openPop.closest('li.grid__item, .quick-add-in-search');
                    if (tile) {
                      const openBtn = tile.querySelector('.js-open-variants[data-handle]');
                      if (openBtn) productHandle = openBtn.getAttribute('data-handle');
                    }
                  }
                }
              }
  
              // 4. Variant butonlarındaki data-handle'ı kontrol et
              if (!productHandle) {
                const variantOption = document.querySelector(`.variant-option[data-variant-id="${requestedVariantId}"]`);
                if (variantOption && variantOption.dataset.handle) {
                  productHandle = variantOption.dataset.handle;
                }
              }
  
              // 5. Wishlist sayfası için: WishlistKing elementlerinden handle ve inventory bul
              if (window.location.pathname.includes('/apps/wishlist')) {
                // Wishlist'teki form veya card'dan handle ve inventory bulmaya çalış
                const allWishlistCards = document.querySelectorAll('wishlist-product-card');
                for (const card of allWishlistCards) {
                  const variantInput = card.querySelector(`input[name="id"]`);
                  if (variantInput && Number(variantInput.value) === requestedVariantId) {
                    // Handle'ı bul
                    if (!productHandle) {
                      const link = card.querySelector('.wk-text-link[href*="/products/"]');
                      if (link) {
                        const href = link.getAttribute('href');
                        const match = href.match(/\/products\/([^/?#]+)/);
                        if (match) {
                          productHandle = match[1];
                        }
                      }
                    }
                    // Inventory bilgisini card'dan al (wishlist-metafield.js tarafından eklenir)
                    if (inventoryFromDOM === null) {
                      // Önce inventoryMap'ten dene (variant değişimlerini destekler)
                      if (card.dataset.inventoryMap) {
                        try {
                          const invMap = JSON.parse(card.dataset.inventoryMap);
                          const inv = invMap[String(requestedVariantId)];
                          if (inv !== undefined) {
                            const invNum = parseInt(inv, 10);
                            if (!isNaN(invNum) && invNum < 999999) {
                              inventoryFromDOM = invNum;
                            }
                          }
                        } catch (e) {}
                      }
                      // Sonra direkt data-inventory'den dene
                      if (inventoryFromDOM === null && card.dataset.inventory) {
                        const inv = parseInt(card.dataset.inventory, 10);
                        if (!isNaN(inv) && inv < 999999) {
                          inventoryFromDOM = inv;
                        }
                      }
                    }
                    break;
                  }
                }
              }
  
              console.log('🛒 Fetch: Handle:', productHandle, '| Inventory from DOM:', inventoryFromDOM, '| In cart:', currentQtyInCart);
  
              // Stok bilgisini al - önce DOM'dan, sonra API'den
              let availableStock = inventoryFromDOM;
  
              // DOM'dan alamadıysak API'den dene
              if (availableStock === null && productHandle) {
                try {
                  const productResponse = await originalFetch(`/products/${productHandle}.js`);
                  const productData = await productResponse.json();
                  const variant = productData.variants.find(v => Number(v.id) === requestedVariantId);
                  if (variant && typeof variant.inventory_quantity === 'number') {
                    availableStock = variant.inventory_quantity;
                  }
                } catch (e) {
                  console.log('🛒 Fetch: Could not fetch product stock info');
                }
              }
  
              console.log('🛒 Fetch: Pre-check - Variant ID:', requestedVariantId, 'Current qty in cart:', currentQtyInCart, 'Trying to add:', requestedQty, 'Available stock:', availableStock);
  
              // PDP sayfasında pre-check yapma - product-form.js Shopify API hatasını gösterecek
              const isPDPPage = window.location.pathname.match(/\/products\/[^/]+$/);
  
              // STOK KONTROLÜ: Sepetteki + eklenecek > stok ise engelle (PDP hariç)
              const shouldBlock = !isPDPPage && availableStock !== null && (currentQtyInCart + requestedQty) > availableStock;
  
              if (shouldBlock) {
                const remainingStock = Math.max(0, availableStock - currentQtyInCart);
                console.warn('🛒 Fetch: BLOCKED - Stock limit exceeded', { availableStock, currentQtyInCart, remainingStock });
  
                // ÖNCE flag'leri set et - wishlist-cart-notification-fix için
                window.__wishlistStockBlocked = requestedVariantId;
                window.__wishlistStockBlockTime = Date.now();
                window.__wishlistPreBlocked = true;
  
                const stockMessage = remainingStock === 0
                  ? (window.themeTranslations?.backInStock || 'Bu üründen daha fazla ekleyemezsiniz. Stok limiti dolmuştur.')
                  : `Bu üründen en fazla ${remainingStock} adet daha ekleyebilirsiniz.`;
  
                // Stok uyarısı göster
                if (window.Toastify) {
                  Toastify({
                    text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${stockMessage}`,
                    duration: 3000,
                    className: 'stock-alert-container',
                    style: {
                      background: "#000",
                      color: "#fff",
                    },
                    escapeMarkup: false,
                    newWindow: true,
                    close: false,
                    gravity: "top",
                    position: toastPosition,
                    stopOnFocus: true,
                    onClick: function () { }
                  }).showToast();
                }
  
                // 1000ms sonra flag'i temizle - wishlist-cart-notification-fix için yeterli süre
                setTimeout(() => {
                  window.__wishlistStockBlocked = null;
                  window.__wishlistStockBlockTime = null;
                }, 1000);
  
                // Sahte başarılı response döndür (işlemi engelle ama hata verme)
                // ÖNEMLI: Notification açılmasını engellemek için özel flag ekle
                const fakeResponseData = {
                  ...currentCart,
                  __stockBlocked: true, // Search page için flag
                  __wishlistStockBlocked: true // Ekstra güvenlik
                };
                delete fakeResponseData.sections; // Notification açılmasını engelle
  
                const fakeResponse = new Response(JSON.stringify(fakeResponseData), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' }
                });
                // Bu response'un pre-check'ten geldiğini işaretle
                fakeResponse.__preCheckBlocked = true;
                return Promise.resolve(fakeResponse);
              }
            }
  
            // Pre-check'te engellendiğini işaretle
            window.__wishlistPreBlocked = false;
  
            // Şimdi asıl add işlemini yap
            return originalFetch.apply(this, args);
          })
          .catch(err => {
            console.warn('🛒 Fetch: Could not fetch cart before add:', err);
            // Hata olsa bile add işlemine devam et
            window.__wishlistPreBlocked = false;
            return originalFetch.apply(this, args);
          })
          .then(async response => {
            // Pre-check'te engellenen fake response'u kontrol et
            if (response.__preCheckBlocked) {
              console.log('🛒 Fetch: Skipping post-response check - already blocked in pre-check');
              return response;
            }
  
            // Response'u klonla çünkü body'yi birden fazla okuyamayız
            const clonedResponse = response.clone();
  
            console.log('🛒 Fetch: Response status:', response.status, response.ok);
  
            if (!response.ok) {
              // Hata varsa, JSON'u al ve işle
              try {
                const errorData = await response.json();
                console.error('🛒 Fetch: Cart add error:', errorData);
  
                // PDP sayfasında product-form.js kendi hata mesajını gösteriyor, duplicate önle
                const isPDP = window.location.pathname.match(/\/products\/[^/]+$/);
                if (isPDP) {
                  console.log('🛒 Fetch: PDP page - skipping toast (product-form handles error)');
                  return clonedResponse;
                }
  
                // Stok hatası mesajını göster
                const errorMsg = errorData?.description || errorData?.message || 'Sepete eklenemedi';
  
                // Toast mesajı göster ve notification'ı kapat
                setTimeout(() => {
                  if (window.Toastify) {
                    Toastify({
                      text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${errorMsg}`,
                      duration: 3000,
                      className: 'stock-alert-container',
                      style: {
                        background: "#000",
                        color: "#fff",
                      },
                      escapeMarkup: false,
                      newWindow: true,
                      close: false,
                      gravity: "top",
                      position: toastPosition,
                      stopOnFocus: true,
                      onClick: function () { }
                    }).showToast();
                  }
  
                  const cartNotification = document.querySelector('cart-notification');
                  if (cartNotification && cartNotification.classList.contains('active')) {
                    cartNotification.classList.remove('active');
                  }
                }, 100);
  
                return clonedResponse;
              } catch (e) {
                console.error('🛒 Fetch: Error parsing error response:', e);
                return clonedResponse;
              }
            }
  
            // Başarılı istek - ama stok kontrolü yap
            try {
              const data = await response.json();
              console.log('🛒 Fetch: Cart response data:', data);
  
              // Request body'den istenen miktarı al
              let requestedQty = 1;
              let requestedVariantIdFromBody = null;
              try {
                if (options?.body instanceof FormData) {
                  requestedVariantIdFromBody = options.body.get('id');
                  requestedQty = parseInt(options.body.get('quantity') || '1', 10);
                } else {
                  const bodyData = JSON.parse(options?.body || '{}');
                  requestedQty = bodyData.quantity || bodyData.items?.[0]?.quantity || 1;
                  requestedVariantIdFromBody = bodyData.id || bodyData.items?.[0]?.id;
                }
              } catch (e) {
                console.log('🛒 Fetch: Could not parse request body, assuming qty=1');
              }
  
              // Response'dan eklenen item'ı bul - requestedVariantIdFromBody'yi kullanarak bul
              let addedItem = null;
              let currentQtyInCart = 0;
              const variantIdNum = requestedVariantIdFromBody ? Number(requestedVariantIdFromBody) : null;
  
              if (data.items && Array.isArray(data.items) && variantIdNum) {
                // Sepetteki bu variant'ı bul
                addedItem = data.items.find(item => Number(item.id) === variantIdNum);
                currentQtyInCart = addedItem ? addedItem.quantity : 0;
              } else if (data.id) {
                // Single item response (eski format)
                addedItem = data;
                currentQtyInCart = data.quantity || 0;
              }
  
              // Önceki sepetteki miktarı bul
              let previousQty = 0;
              if (cartBeforeAdd && cartBeforeAdd.items && variantIdNum) {
                const previousItem = cartBeforeAdd.items.find(item => Number(item.id) === variantIdNum);
                previousQty = previousItem ? previousItem.quantity : 0;
              }
  
              const actuallyAddedQty = currentQtyInCart - previousQty;
  
              console.log('🛒 Fetch: Requested qty:', requestedQty, 'Previous qty:', previousQty, 'Current qty in cart:', currentQtyInCart, 'Actually added:', actuallyAddedQty);
  
              // STOK SORUNU KONTROLÜ:
              // 1. Hiç eklenemediyse (actuallyAddedQty === 0)
              // 2. İstenen miktardan az eklendiyse (actuallyAddedQty < requestedQty)
              const hasStockIssue = actuallyAddedQty === 0 || actuallyAddedQty < requestedQty;
  
              if (hasStockIssue) {
                const stockMessage = actuallyAddedQty > 0
                  ? (window.themeTranslations?.stockLimit || `Stokta bulunmaması nedeniyle sepetinize yalnızca ${actuallyAddedQty} ürün eklendi.`)
                  : (window.themeTranslations?.backInStock || 'Ürün stokta bulunmamaktadır.');
  
                console.warn('🛒 Fetch: Stock limit detected!', {
                  requestedVariantId: requestedVariantIdFromBody,
                  previousQty: previousQty,
                  currentQtyInCart: currentQtyInCart,
                  actuallyAddedQty: actuallyAddedQty,
                  requestedQty: requestedQty,
                  hasStockIssue: hasStockIssue,
                  stockMessage: stockMessage
                });
  
                // Flag set et - notification'ı kapat
                window.__wishlistStockBlocked = requestedVariantIdFromBody || addedItem.id;
                window.__wishlistStockBlockTime = Date.now();
  
                // Toast mesajı göster ve notification'ı kapat
                setTimeout(() => {
                  if (window.Toastify) {
                    Toastify({
                      text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${stockMessage}`,
                      duration: 3000,
                      className: 'stock-alert-container',
                      style: {
                        background: "#000",
                        color: "#fff",
                      },
                      escapeMarkup: false,
                      newWindow: true,
                      close: false,
                      gravity: "top",
                      position: toastPosition,
                      stopOnFocus: true,
                      onClick: function () { }
                    }).showToast();
                  }
  
                  const cartNotification = document.querySelector('cart-notification');
                  if (cartNotification && cartNotification.classList.contains('active')) {
                    cartNotification.classList.remove('active');
                  }
                }, 100);
  
                // 1000ms sonra flag'i temizle
                setTimeout(() => {
                  window.__wishlistStockBlocked = null;
                  window.__wishlistStockBlockTime = null;
                }, 1000);
              } else {
                console.log('🛒 Fetch: Request successful - no stock issues');
              }
            } catch (e) {
              console.error('🛒 Fetch: Error checking stock:', e);
            }
  
            return clonedResponse;
          })
          .catch(error => {
            console.error('🛒 Fetch: Network error:', error);
            throw error;
          });
      }
  
      // Diğer istekler için normal fetch
      return originalFetch.apply(this, args);
    };
  
    console.log('🛒 Wishlist: Fetch & XHR interceptors installed');
  
  })();